export const MARKER_ANCHOR = {
  EDITING: { x: 12, y: 35 },
  NORMAL: { x: 12, y: 24 },
};

export const POPUP_STYLE = {
  position: 'absolute',
  background: 'white',
  padding: '10px 12px',
  borderRadius: '4px',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
  fontFamily: "'FiraGO', sans-serif",
  fontSize: '11px',
  color: 'rgba(15, 22, 33, 0.5)',
  minWidth: '250px',
  maxWidth: '350px',
  zIndex: '10000',
  pointerEvents: 'none',
  transform: 'translate(-50%, -100%)',
  marginTop: '-10px',
};

export const ARROW_STYLE = {
  position: 'absolute',
  bottom: '-6px',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '0',
  height: '0',
  borderLeft: '6px solid transparent',
  borderRight: '6px solid transparent',
  borderTop: '6px solid white',
};

export const PANEL_WIDTH_PX = 26 * 16;
export const PADDING_PERCENT = 0.1;
